import { useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

import withMapPanelSizing from "./withMapPanelSizing";
import { MapPanelContext } from "./MapPanel";
import { useMapContext } from "../MapContext";

const MapPanelDesktop = ({ style = {}, ...props }) => {
  const { id, containerPanelRef, innerPanelRef, height, children } = props;

  const { mapKey } = useMapContext();
  const isShown = useSelector(({ map }) => map[mapKey].panels.activePanels[id]?.isShown);

  const [mapPanelActionsContainer, setMapPanelActionsContainer] = useState();

  const className = classNames("map-panel", "box-shadow-lg", props.className);

  const display = isShown ? "block" : "none";
  style = { height, display, ...style };
  const innerPanelStyle = { overflowY: height === "auto" ? null : "scroll" };

  return (
    <MapPanelContext.Provider value={{ mapPanelActionsContainer }}>
      <div
        className={className}
        style={style}
        ref={containerPanelRef}
        data-map-panel={id}
      >
        <div className="map-panel-inner" ref={innerPanelRef} style={innerPanelStyle}>
          <div className="padding-xs boxes-list">{children}</div>
        </div>

        <div className="map-panel-actions-container" ref={setMapPanelActionsContainer} />
      </div>
    </MapPanelContext.Provider>
  );
};

export default withMapPanelSizing(MapPanelDesktop);
